import React from "react";
import LoadingPlaceholder from "./LoadingPlaceholder";

export const ImageLoadingPlaceholder = React.memo(function ImageLoadingPlaceholder(
  props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
): JSX.Element {
  return (
    <div {...props} className={[props.className, "ImageLoadingPlaceholder"].join("")}>
      <LoadingPlaceholder />
    </div>
  );
});
